'use client';

import LinkButton from '@/components/atoms/linkButton';
import { BlockComponentModel } from '@/components/cms/types/blok-component';

import { Scraper } from './Scraper';
import { ScraperProvider } from './state/context';
import { BlockHeader, BlockHeaderContent } from '../utils/BlockHeaderContent';
import { BlockWrapper } from '../utils/BlockWrapper';

import IconOnboarding from '~/svg/IconOnboarding.svg';

export interface ScraperStrapiProps {
  header: BlockHeader;
  target: string;
}

export const ScraperStrapi = ({
  block,
}: BlockComponentModel<ScraperStrapiProps>) => {
  const { buttons, ...blockHeader } = block.header ?? {};
  const cta = buttons?.[0];

  return (
    <BlockWrapper data-tracker-section='scraper'>
      <BlockHeaderContent
        {...blockHeader}
        buttonPosition='top'
        classNames={{
          button: 'flex md:hidden',
        }}
        renderButtons={
          !!cta
            ? [
                () => (
                  <LinkButton
                    key={cta.url}
                    data-tracker-context='get-trial'
                    fullwidth
                    href={cta.url}
                    variant='filled'
                    color='primary'
                    leftSection={<IconOnboarding />}
                  >
                    {cta.text}
                  </LinkButton>
                ),
              ]
            : []
        }
      >
        <ScraperProvider dashboardAction={cta} initialTarget={block.target}>
          <Scraper />
        </ScraperProvider>
      </BlockHeaderContent>
    </BlockWrapper>
  );
};
